<template>
  <div>
    <tableComponent
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      @newDocument="newDocument"
      @confirmBulkDelete="confirmBulkDelete"
    />
    <v-dialog v-model="bulkConfirm.open" max-width="440">
      <v-card>
        <v-card-title>{{ bulkConfirm.title }}</v-card-title>
        <v-card-text>{{ bulkConfirm.message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="bulkConfirm.open = false"
            :disabled="bulkConfirm.loading"
          >
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn
            color="error"
            :loading="bulkConfirm.loading"
            @click="runBulkDelete"
          >
            {{ $t("environmentalReports.bulk.deleteButton") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getUniqueId } from "../../components/api/api";
import tableComponent from "../../components/_utils/dataTableHelpers/tableComponent.vue";

export default {
  components: { tableComponent },
  data: () => ({
    currentUserId: "",
    tableSettings: {
      title: "",
      showSelect: true,
      showHeaderToolbar: true,
      multipleSelectButtons: [
        {
          title: "environmentalReports.bulk.deleteButton",
          color: "error",
          action: "confirmBulkDelete",
          icon: "delete",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
      headerButtons: [
        {
          title: "environmentalReports.create",
          color: "secondary",
          action: "newDocument",
          icon: "add",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
    },
    bulkConfirm: {
      open: false,
      loading: false,
      title: "",
      message: "",
      ids: [],
    },
    tableData: {
      tableComponentSlots: [
        {
          id: getUniqueId(),
          slotName: "item.environmentalReportDate",
          componentName: "environmentalReportDate",
        },
        {
          id: getUniqueId(),
          slotName: "item.environmentalReportResponsible",
          componentName: "environmentalReportResponsible",
        },
        {
          id: getUniqueId(),
          slotName: "item.environmentalReportProofStatus",
          componentName: "environmentalReportProofStatus",
        },
        {
          id: getUniqueId(),
          slotName: "item.environmentalReportAction",
          componentName: "environmentalReportAction",
          config: { currentUserId: "" },
        },
      ],
      itemKey: "_id",
      uriPartPrepend: "environmentalReport",
      uriPartAppend: "",
      populate: ["responsible"],
      sort: "-date",
      editFormPushName: "environmentalReportForm",
    },
  }),
  created() {
    this.$store.dispatch("getUserInfo").then((user) => {
      this.currentUserId = user?._id || "";
      const slot = this.tableData.tableComponentSlots.find(
        (x) => x.componentName === "environmentalReportAction"
      );
      if (slot) slot.config = { currentUserId: this.currentUserId };
    });
    const { year, month } = this.$route.params;
    if (year && month) {
      this.tableData.uriPartAppend = `&year=${year}&month=${month}`;
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("environmentalReports.tableHeader.name"),
          value: "name",
          align: "left",
        },
        {
          text: this.$t("environmentalReports.tableHeader.date"),
          value: "environmentalReportDate",
        },
        {
          text: this.$t("environmentalReports.tableHeader.description"),
          value: "description",
          sortable: false,
        },
        {
          text: this.$t("environmentalReports.tableHeader.responsible"),
          value: "environmentalReportResponsible",
          sortable: false,
        },
        {
          text: this.$t("riskAssessment.tableHeader.proofed"),
          value: "environmentalReportProofStatus",
          sortable: false,
        },
        {
          text: "",
          value: "environmentalReportAction",
          align: "right",
          sortable: false,
          width: 160,
        },
      ];
    },
  },
  methods: {
    newDocument() {
      const { year, month } = this.$route.params;
      this.$router.push({
        name: this.tableData.editFormPushName,
        params: { id: "1", mode: "new", data: 1 },
        query: year && month ? { year, month } : {},
      });
    },
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
    },
    confirmBulkDelete(selectedItems) {
      const ids = (selectedItems || []).map((i) => i._id);
      this.bulkConfirm = {
        open: true,
        loading: false,
        title: this.$t("environmentalReports.bulk.deleteTitle"),
        message: this.$t("environmentalReports.bulk.deleteConfirm", {
          count: ids.length,
        }),
        ids,
      };
    },
    async runBulkDelete() {
      this.bulkConfirm.loading = true;
      try {
        await this.$store.dispatch(
          "bulkDeleteEnvironmentalReports",
          this.bulkConfirm.ids
        );
        this.bulkConfirm.open = false;
        this.reloadDataFunc();
      } finally {
        this.bulkConfirm.loading = false;
      }
    },
  },
};
</script>
